import { render, staticRenderFns } from "./MediaAdvertiserStat.vue?vue&type=template&id=48479676&scoped=true"
import script from "./MediaAdvertiserStat.vue?vue&type=script&lang=js"
export * from "./MediaAdvertiserStat.vue?vue&type=script&lang=js"
import style0 from "./MediaAdvertiserStat.vue?vue&type=style&index=0&id=48479676&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48479676",
  null
  
)

export default component.exports